import { EarningsInsight, EventFeedEvent } from '@toggle/toggle';

const eventToEarningsInsight = (
  event: EventFeedEvent
): EarningsInsight | null => {
  if (event.type !== 'earnings-insight') {
    return null;
  }

  const earningsType = event.metadata.earnings_type;
  const earningsId = event.metadata.earnings_id;

  if (!earningsType || !earningsId) {
    return null;
  }

  return {
    id: event.source_id,
    type: earningsType,
    entity_tag: event.entity,
    earnings_id: earningsId,
    title: event.title,
    created_at: event.created_at,
    updated_at: event.created_at,
  };
};

export interface EarningsInsightWithEvent {
  earningsInsight: EarningsInsight;
  eventId: string;
  read: boolean;
}

/** Prefer recap over preview, then build EarningsInsightWithEvent from the chosen event. */
const parseEarningsInsightEvent = (
  earningsInsightEvents: EventFeedEvent[]
): EarningsInsightWithEvent | undefined => {
  if (earningsInsightEvents.length === 0) {
    return undefined;
  }
  const recap = earningsInsightEvents.find(
    e => e.metadata.earnings_type === 'recap'
  );
  const preview = earningsInsightEvents.find(
    e => e.metadata.earnings_type === 'preview'
  );
  const selectedEvent = recap ?? preview ?? earningsInsightEvents[0];
  const earningsInsight = eventToEarningsInsight(selectedEvent);
  if (!earningsInsight) {
    return undefined;
  }
  return {
    earningsInsight,
    eventId: selectedEvent.id,
    read: selectedEvent.read,
  };
};

/** From all events, pick one earnings insight (prefer recap over preview). */
export const parseEarningsInsightFromEvents = (
  events: EventFeedEvent[]
): EarningsInsightWithEvent | undefined => {
  const earningsInsightEvents = events.filter(
    e => e.type === 'earnings-insight'
  );
  return parseEarningsInsightEvent(earningsInsightEvents);
};

/** From events, pick the earnings insight for the given earnings ID (prefer recap over preview). */
export const getEarningsInsightWithEventByEarningsId = (
  events: EventFeedEvent[],
  earningsId: string
): EarningsInsightWithEvent | undefined => {
  const forEarnings = events.filter(
    e => e.type === 'earnings-insight' && e.metadata.earnings_id === earningsId
  );
  return parseEarningsInsightEvent(forEarnings);
};
